import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { JOB_MODAL_ID } from './components/JobModal/JobModal-constants';

import { useCurrentJob, useDownloadPdf } from '../../hooks';
import { formatDate, formatName } from '../../utils';

const ContainerComponent = ({ children }) => {
  const { job, jobInfo, jobCompanyInfo, introduction, isLoading } =
    useCurrentJob();

  const { downloadPdf, isSubmitting } = useDownloadPdf();
  const { showModal } = useContext(ModalsWrapperContext);

  const name = formatName(job?.customer);
  const date = formatDate(job?.metadata?.created_at);

  const items = isLoading ? ['0', '1'] : [name, date].filter(Boolean);

  const title = job?.title || '';
  const total = job?.total?.amount_vat_inclusive?.amount || 0;

  const onClick = useCallback(() => showModal(JOB_MODAL_ID), [showModal]);

  const onPdfClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (
        !jobInfo ||
        !jobCompanyInfo ||
        (jobInfo?.introduced_to && !introduction)
      )
        return;
      downloadPdf(jobInfo, jobCompanyInfo, introduction);
    },
    [jobInfo, jobCompanyInfo, introduction, downloadPdf],
  );

  return children({
    onClick,
    items,
    isLoading,
    title,
    total,
    onPdfClick,
    isSubmitting,
  });
};

ContainerComponent.displayName = 'JobButton-container';

export default ContainerComponent;
